import { InjectionToken } from '@angular/core';
import { AuthConfig } from '@auth0/auth0-angular';
import { MsalAuthEnvironmentConfig } from './msal-auth-config.interface';

export const EnvironmentInstanceToken = new InjectionToken<PaceEnvironment>('PaceEnvironment');

export interface PaceEnvironment {
    production: boolean;
    appId: string;
    apiBase: string;
    apiSapProxy: string;
    operateInMockMode: boolean;
    reportIssueSupportEmail: string;
    bundleIdentifierName: string;
    subscriptionServerPublicKey?: string;
    complaintsLinkPath?: string;
    auth0?: AuthConfig;
    msal?: MsalAuthEnvironmentConfig;
    appInsightsConnectionString?: string;
    /**
     * When true, every domain the NgRx migration covers is served from its store slice rather than by
     * the legacy service, and the store-connected dashboard, timesheet and notification-details screens
     * render in place of the originals. Optional and off by default, which is what every environment
     * without it gets — production included.
     *
     * One flag rather than one per domain because the domains are not independently switchable: they
     * read and write each other's slices, so a domain left on a legacy implementation would work off a
     * different copy of the same data. The notification slice and the statuses that sit on its
     * notifications are the clearest case — neither works without the other. Travel status update is
     * the same kind of case: it has no slice of its own and only orchestrates writes to the
     * notification and timesheet slices, so it has to run against the same store copy those two do.
     *
     * Flipping it also changes where some data lives: recipients move between encrypted file storage and
     * the generic slice-persistence layer, and the user-master selection and measurement tools between
     * localStorage and encrypted IndexedDB. Those backends do not share storage, so a saved collection
     * does not carry across the flip in either direction.
     */
    enableNgRx?: boolean;
}
